import { useEffect, useState } from "react";
import api from "@/lib/api";
import { AlertTriangle, X, Info, AlertOctagon, ExternalLink } from "lucide-react";

const LEVELS = {
  info:    { bg: "bg-blue-600",   Icon: Info,          text: "text-white" },
  warning: { bg: "bg-amber-500",  Icon: AlertTriangle, text: "text-[#0F172A]" },
  danger:  { bg: "bg-red-600",    Icon: AlertOctagon,  text: "text-white" },
};

export default function EmergencyBanner() {
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get("/site-info").then((r) => {
      if (r.data?.emergency_banner_active && r.data?.emergency_banner_message) {
        const key = `in21_eb_${btoa(unescape(encodeURIComponent(r.data.emergency_banner_message))).slice(0, 20)}`;
        if (localStorage.getItem(key)) { setDismissed(true); return; }
        setBanner({ ...r.data, _key: key });
      }
    }).catch(() => {});
  }, []);

  if (!banner || dismissed) return null;
  const cfg = LEVELS[banner.emergency_banner_level] || LEVELS.warning;
  const dismiss = () => { try { localStorage.setItem(banner._key, "1"); } catch {} setDismissed(true); };

  return (
    <div className={`${cfg.bg} ${cfg.text} shadow-md relative z-40 animate-pulse-slow`} data-testid="emergency-banner">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center gap-3">
        <cfg.Icon className="w-5 h-5 shrink-0 animate-pulse"/>
        <span className="text-[10px] uppercase tracking-[0.28em] font-black shrink-0 hidden md:inline">
          {banner.emergency_banner_level === "danger" ? "🚨 आपात सूचना" : banner.emergency_banner_level === "info" ? "जानकारी" : "⚠️ चेतावनी"}
        </span>
        <span className="flex-1 text-sm md:text-base font-devnagri-heading font-bold leading-snug">{banner.emergency_banner_message}</span>
        {banner.emergency_banner_link && (
          <a href={banner.emergency_banner_link} target="_blank" rel="noopener noreferrer"
            className="hidden sm:inline-flex items-center gap-1 bg-black/25 hover:bg-black/40 rounded-full px-3 py-1 text-xs font-bold whitespace-nowrap">
            विवरण <ExternalLink className="w-3 h-3"/>
          </a>
        )}
        <button onClick={dismiss} className="p-1 rounded-full hover:bg-black/25 shrink-0" aria-label="बंद करें" data-testid="emergency-dismiss">
          <X className="w-4 h-4"/>
        </button>
      </div>
    </div>
  );
}
